import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { UndoIcon } from '@diligentcorp/atlas-react-icons';
import { useDataGridContext } from '../../data-grid-context';

type Props = {
  onReset?: () => void;
};

export function GridToolbarResetButton({ onReset }: Props) {
  const { t } = useTranslation('common');

  const dataGridContext = useDataGridContext();

  const handleClick = () => {
    onReset?.();
    dataGridContext.resetGridState();
  };

  return (
    <Button startIcon={<UndoIcon />} onClick={handleClick}>
      {t('dataGrid.reset')}
    </Button>
  );
}
